import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Button,
  ModalFooter,
  Checkbox,
  SimpleGrid,
  Spacer,
  Switch,
  FormControl,
  FormLabel,
  background,
} from "@chakra-ui/react";
import { connect } from "react-redux";
// import epl from "../eplstyles";
import { epl } from "../clientstyles/epl"
import { edp } from "../clientstyles/edp"
import { eplStyles } from "../clientstyles/commonstyles"
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import manageStyle from "../NewPages/Dashboardcomponents/Managestyles.module.css";
import { useParams } from "react-router-dom";
import UseTexFile from "./Customhook/UseTexFile";
// import { Tooltip } from "@chakra-ui/react";


const Styling = (props) => {
  // const { texFile, setTexFile } = UseTexFile();
  const [stylesList, setStyleList] = useState([]);
  const [tooltip, setTooltip] = useState({ id: "" });
  const [client, setClient] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [selecteddescription, setSelectedDescription] = useState({ name: epl[0]?.name });
  const [searchStyles, setSearchStyles] = useState("");
  const { projectid, file } = useParams();


  const [submitted, setSubmitted] = useState(false);
  const [shownStyles, setShownStyles] = useState({}); // the subset object from eplStyles

  useEffect(() => {
    const isInternal = props.projectDetails?.is_internal;
    const projectName = props.projectDetails?.name || "";

    let subset;

    // if (isInternal && projectName.toLowerCase().startsWith("epl")) {
    if (isInternal && projectName.toLowerCase().startsWith("epl")) {
      subset = epl;
    } else if (isInternal && projectName.toLowerCase().startsWith("edp")) {
      subset = edp;
    }

    else {
      const localdata = localStorage.getItem("client");
      const clientArray = localdata ? JSON.parse(localdata) : [];
      const existingEntry = clientArray.find(item => item.id === projectid);
      const savedKeys = existingEntry?.styles || [];

      if (savedKeys.length > 0) {
        let styles = { ...eplStyles, ...edp, ...epl }
        subset = savedKeys.reduce((acc, key) => {
          if (styles[key]) acc[key] = styles[key];
          return acc;
        }, {});
      } else {
        let styles = { ...eplStyles, ...edp, ...epl }
        // subset = eplStyles;
        subset = styles;
      }
    }

    setShownStyles(subset);
    setClient(subset);

    const firstKey = Object.keys(subset)[0];
    if (firstKey) {
      setSelectedDescription({ name: firstKey, value: subset[firstKey] });
    }

    const selectedData = localStorage.getItem("selectedStyles");
    const selectedJson = selectedData ? JSON.parse(selectedData) : null;
    const selectedEntry = Array.isArray(selectedJson)
      ? selectedJson.find((entry) => entry.id === projectid)
      : null;

    if (selectedEntry?.selectedStyles?.length > 0) {
      setStyleList(selectedEntry.selectedStyles);
    } else {
      setStyleList(Object.keys(subset));
    }

  }, [props.isOpen]);

  const filteredStyles = Object.entries(shownStyles).filter(([keyName, value]) => {
    if (!searchStyles.trim()) return true;
    const q = searchStyles.toLowerCase().trim();
    const matchesWordStart = (text) => {
      if (!text) return false;
      return text.toLowerCase().split(/[\s_/]+/).some(word => word.startsWith(q));
    };
    return matchesWordStart(keyName) || matchesWordStart(value?.name);
  });


  const updateSelectedStyles = function (checked, data) {
    if (checked) {
      setStyleList([...stylesList, data]);
    } else {
      let filtered = stylesList.filter(function (el) {
        return el !== data;
      });
      setStyleList(filtered);
    }
  };
  const navigate = useNavigate()
  const checkAll = (checked) => {
    if (checked) {
      setStyleList(Object.keys(shownStyles));
    } else {
      setStyleList([]);
    }
  };

  const handleClick = () => {
    // 1. Save selected styles to localStorage
    const existingData = localStorage.getItem("selectedStyles");
    const selectedArray = existingData ? JSON.parse(existingData) : [];
    const existingIndex = selectedArray.findIndex(item => item.id === projectid);

    const newEntry = {
      id: projectid,
      selectedStyles: stylesList,
    };

    if (existingIndex !== -1) {
      selectedArray[existingIndex] = newEntry;
    } else {
      selectedArray.push(newEntry);
    }
    localStorage.setItem("selectedStyles", JSON.stringify(selectedArray));


    props.editToolRejected();
    props.clearautosuggestion();
    props.clearAutoSuggestionRejects();


    const editor = props.ace?.current?.editor;
    if (editor) {
      const session = editor.session;
      props.autoSuggestions?.forEach(item => {
        if (item.markerId) session.removeMarker(item.markerId);
        if (item.startAnchor?.detach) item.startAnchor.detach();
        if (item.endAnchor?.detach) item.endAnchor.detach();
      });
    }

    if (!props.showIsChecked) {
      props.autoapplyonoff();
    }
    props.showsuggestion();
    props.showautosuggestion();
    props.setRightController((prevState) => ({ ...prevState, view: "suggestions" }));
    navigate("#suggestions");

    setSearchStyles("");
  };


  useEffect(() => {
    if (props.isChecked) {
      setIsChecked(true)
      setStyleList(props.editToolStyles[props?.currentClient] || [])
    }
    else {
      setIsChecked(false)
    }
  }, [props.isOpen])

  const searchingStyles = (e) => {
    setSearchStyles(e.target.value)
  }

  return (
    <Modal size={"4xl"} onClose={props.onClose} isOpen={props.isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {/* {props.currentClient} */}
          Styles
          <Spacer />
          <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
            <Checkbox
              isChecked={Object.keys(shownStyles).length > 0 && stylesList.length === Object.keys(shownStyles).length}
              onChange={(e) => checkAll(e.target.checked)}
              style={{ marginTop: "10px" }}
            >
              Select All
            </Checkbox>
            <FormControl style={{ width: "fit-content" }} display="flex" alignItems="center" justifyContent="end">
              <FormLabel style={{ fontSize: "15px", cursor: "pointer" }} htmlFor="interactive" mb="0">
                Interactive mode
              </FormLabel>
              <Switch
                id="interactive"
                isChecked={props.showIsChecked}
                // onChange={(e) => setIsChecked(e.target.checked)}
                onChange={(e) => { props.changeisChecked(); }}
                colorScheme="blue"
                size="sm"
              />
            </FormControl>
          </div>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>

          <div className={manageStyle.searchContainer}>
            <input type='text' value={searchStyles} onChange={searchingStyles}
              className={manageStyle.searchinput}
            />
            <svg className={manageStyle.searchicon} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
              <path d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 20 22 L 22 20 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z"></path>
            </svg>
          </div>
        </ModalBody>
        <div className={manageStyle.BothSideContainer}>
          <div className={manageStyle.LeftsideContainer}>
            <div className={manageStyle.ProjectstylePreviewContainer}>
              {filteredStyles.map(([i, value]) => (
                <div key={i} className={`${selecteddescription?.name === i && manageStyle.currentDiscription} ${manageStyle.projectStyleNames}`}>
                  <Checkbox
                    className="checkbox"
                    isChecked={stylesList.includes(i)}
                    onChange={(e) => updateSelectedStyles(e.target.checked, i)}
                    key={epl[i]?.name}
                  >
                    <div onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSelectedDescription({ name: i, value: value });
                    }}

                      className={manageStyle.individualstyle}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >

                      <div
                        style={{
                          fontSize: "14px",
                          gap: "4px",
                          display: "flex",
                          alignItems: "center",
                          width: "300px",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="stylingTextColor">{client[i]?.name}</div>
                        <div>
                          <InfoOutlineIcon />
                        </div>
                      </div>
                    </div>
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>
          <div className={manageStyle.RightsideContainer}>
            <div className={manageStyle.ProjectdescriptionViewContainer}>

              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px"
              }}>
                <h1 className={manageStyle.Textcolor}>{selecteddescription?.name}</h1>
              </div>

              <div style={{ color: "#222" }}>
                <h3 className={manageStyle.Textcolor}>Description:</h3>
                <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>{selecteddescription?.value?.description || "No description available"}</p>
                <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>Before:</p>
                {selecteddescription?.value?.beforeImage && (
                  <img
                    src={process.env.PUBLIC_URL + selecteddescription.value.beforeImage}
                    alt="After"
                    style={{ paddingBottom: "10px" }}
                  />
                )}

                <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>After:</p>
                {selecteddescription?.value?.afterImage && (
                  <img
                    src={process.env.PUBLIC_URL + selecteddescription.value.afterImage}
                    alt="After"
                    style={{ paddingBottom: "10px" }}
                  />
                )}
              </div>
            </div>

          </div>
        </div>


        <ModalFooter>
          <Button
            style={{}}
            onClick={() => {
              if (stylesList.length === 0) {
                props.toast({ title: "Select any style", status: "error", duration: 1000 });
                return;
              }
              handleClick();
              props.onClose();
            }}
            mx={2}
            bg="var(--btn-bg)"
            color="var(--btn-text)"
            _hover={{ bg: "var(--btn-hover)" }}
          >
            Submit
          </Button>
          <Button onClick={() => { props.onClose(); setSearchStyles(""); }}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
const mapStateToProps = (state, ownProps) => ({
  editToolStyles: state.toolStyles.function,
  isChecked: state.toolStyles.isChecked,
  showIsChecked: state.autoSuggestion.isChecked,
  showSuggestion: state.editToolRejected.showSuggestion,
  changeclient: state.clientSelect.changeclient,
  autoSuggestions: state.autoSuggestion.suggestions,
})
const mapDispatchToProps = (dispatch) => {
  return {
    eplStyles: (data) => dispatch({ type: "Submit", payload: data }),
    toolStyles: (data) => dispatch({ type: "ToolSubmit", payload: data }),
    editToolRejected: () => dispatch({ type: "EmptyReject", payload: [] }),
    editToolAction: (data) => dispatch({ type: "EDITTOOL", payload: data }),
    // showsuggestion: () => dispatch({ type: "showsuggestion" }),
    NoSuggestions: () => dispatch({ type: "Dontshowsuggestion" }),
    changeisChecked: () => dispatch({ type: "changeIsChecked" }),
    showautosuggestion: () => dispatch({ type: "toggleautosuggestion" }),
    onIsChecked: () => dispatch({ type: "onIsChecked" }),
    showsuggestion: () => dispatch({ type: "showsuggestion" }),
    clearautosuggestion: () => dispatch({ type: "clearAutoSuggestion" }),
    clearAutoSuggestionRejects: () => dispatch({ type: "EmptyAutoSuggestionReject" }),
    autoapplyonoff: () => dispatch({ type: "autoapplyonoff" })
    // submitAction: (res) => dispatch({ type: "onChange", payload: res }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Styling);
